import React, { useEffect } from 'react';

import { hasPermission } from '@app/helpers/permissions';
import { getUrlManualProcedimentos } from '@app/api/sas/manuaisEProcedimentos';
import { useRouter } from '@digital/ui';

const ManuaisEProcedimentos = () => {
  const [url, setUrl] = React.useState('');

  const {history} = useRouter();
  useEffect(() => {
    getUrlManualProcedimentos().then(response => {
      if (response) {
        setUrl(response);
      }
    });
  }, []);

  const renderIndex = () => {
    window.open(url, '_blank');
    history.goBack();
    return <></>;
  };

  return hasPermission(['SAS_MANUAIS_E_PROCEDIMENTOS_MENU']) && url ? renderIndex() : <></>;
};

export default ManuaisEProcedimentos;
